import "./widget.scss";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import baseUrl from "../../utils/config";
import newRequest from "../../utils/newRequest";
import { useTranslation } from "react-i18next";

const Widget = ({ type }) => {
  let data;
  // get all active users
  // get all inactive users
  const [users, setUsers] = useState([]);
  const [totalassets, setTotalAssets] = useState([]);

  const { t, i18n } = useTranslation();
  const [verifiedAssets, setVerifiedAssets] = useState([]);
  useEffect(() => {
    // /users/stat

    newRequest.get("/getStats").then((response) => {
      setUsers(response?.data?.totalusers ?? []);
      setTotalAssets(response?.data?.totalassets ?? []);
      setVerifiedAssets(response?.data?.verifiedAssets ?? []);
    }).catch((error) => {
      console.log(error);
    }
    );
  }, []);




  //temporary
  const amount = 100;
  // const diff = 20;

  switch (type) {
    case "allUser":
      data = {
        title: t("All USERS"),
        number: users,
        isMoney: false,
        // link: "See all users",
        icon: (
          <PersonOutlinedIcon
            className="icon"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;
    case "activeUser":
      data = {
        title: t("TOTAL CAPTURED ASSETS"),
        number: totalassets,
        isMoney: false,
        // link: "See Active users",
        icon: (
          <PersonOutlinedIcon
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    case "inActiveUser":
      data = {
        title: t("TOTAL VERIFIED ASSETS"),
        number: verifiedAssets,
        isMoney: false,
        // link: "See Inactive users",
        icon: (
          <PersonOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
            }}
          />
        ),
      };
      break;

    case "order":
      data = {
        title: t("ORDERS"),
        isMoney: false,
        link: "View all orders",
        icon: (
          <ShoppingCartOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
            }}
          />
        ),
      };
      break;
    case "earning":
      data = {
        title: t("EARNINGS"),
        isMoney: true,
        link: "View net earnings",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    case "balance":
      data = {
        title: t("BALANCE"),
        isMoney: true,
        link: "See details",
        icon: (
          <AccountBalanceWalletOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(128, 0, 128, 0.2)",
              color: "purple",
            }}
          />
        ),
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.isMoney && "$"} {data.number}
        </span>
        <span className="link">{data.link}</span>
      </div>
      <div className="right">
        <div className="percentage positive">
          <KeyboardArrowUpIcon />
          {/* {diff} % */}
        </div>
        {data.icon}
      </div>
    </div>
  );
};

export default Widget;
